var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basket[data-v-69dadce8]{width:48px;height:48px;position:absolute;top:8px;left:8px;z-index:2;border:none;cursor:pointer;background-color:transparent;background-repeat:no-repeat;background-image:url(" + escape(require("./images/basket_sprite.svg")) + ");overflow:hidden}.basket_add[data-v-69dadce8]{background-position:0 0}.basket_add[data-v-69dadce8]:hover{background-position:0 98%}.basket_remove[data-v-69dadce8]{background-position:100% 0}.basket_remove[data-v-69dadce8]:hover{background-position:100% 98%}.basket_disabled[data-v-69dadce8]{opacity:.25;filter:grayscale(100%);cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69dadce8","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/card/components/modulebasketbutton/ModuleBasketButton.vue
// module id = 95d72f24c9918ffbbcb3
// module chunks = 0